import React from 'react';
import Survey, { CssNames } from '../../Survey';
import SociodemographicsSurvey from './sociodemographics';
import SociodemographicsWrapper from './Sociodemographics.styles';

class Sociodemographics extends React.Component {
  // state = { stage: 0, big5: null, matrix: null };
  //Define a callback methods on survey complete

  onComplete = async (survey, options) => {
    // Write survey results into database
    // console.log('Survey results: ');
    // const { data } = survey;
    // console.log(data);
    // await this.setState(prev => ({ big5: data, stage: prev.stage + 1 }));
    // console.log('Survey results: ');
    const { data } = survey;
    const { onComplete } = this.props;
    const {
      CHILDREN,
      CHILDREN_N,
      CHILDREN_N_DETAILS,
      CIVIL_STATUS,
      STUDY_03,
      STUDY_04
    } = data;
    const parsed = {
      CHILDREN,
      CHILDREN_N,
      ...CHILDREN_N_DETAILS,
      CIVIL_STATUS,
      STUDY_03,
      STUDY_04
    };
    await onComplete(parsed);
  };

  render() {
    const SociodemographicsModel = new Survey.Model(SociodemographicsSurvey);
    return (
      <SociodemographicsWrapper>
        <div className='edu_header'>
          <img
            className='edu-logo'
            src='https://res.cloudinary.com/dpveipnvx/image/upload/v1564630271/uaimetrics/uai_white.png'
            alt='edu-logo'
          />
        </div>
        <Survey.Survey
          model={SociodemographicsModel}
          css={CssNames}
          onComplete={this.onComplete}
        />
        <div className='Footer'>
          {/* <img
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564629089/uaimetrics/Logo_edu-corporate-2.png"
            alt="edu-corporate"
          /> */}
          {/* <img
            className="btg-logo"
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564629090/uaimetrics/BTG-Pactual-HP_Logo.jpg"
            alt="btg-pactual"
          /> */}
        </div>
        <div className='PushStickyFooter'></div>
        <div className='Plug'>
          <a
            href='http://www.edumetrics.cl/'
            target='_blank'
            rel='noopener noreferrer'
          >
            EduMetrics
          </a>
        </div>
      </SociodemographicsWrapper>
    );
  }
}

export default Sociodemographics;
